module.exports = __webpack_public_path__ + "img/UF-logo.e1e13d69.png";